<div class="title" #title>
  <div class="container container-max-width">
    <div>
      <h4>Approve Ad Hoc Requests</h4>
      <p>All Ad Hoc Requests awaiting approval</p>
    </div>
    <div class="action-container">
      <div class="flex-center" *ngIf="showApprovalActions()">
        <span>{{ selectedRowCount }} of {{ rowData.length }} selected &nbsp;&nbsp;|&nbsp;&nbsp;</span>
      </div>
      <div class="form-check form-check-inline toggle">
        <input
          type="checkbox"
          class="form-check-input"
          id="showMyServiceTeamPfRequestsOnlySwitch"
          [(ngModel)]="showMyServiceTeamRequestsOnly"
          (change)="onShowMyServiceTeamRequestsOnlyChanged()"
        />
        <label class="form-check-label" for="showMyServiceTeamPfRequestsOnlySwitch">Show my service team requests only</label>
      </div>
      <div class="form-check form-check-inline toggle">
        <input
          type="checkbox"
          class="form-check-input"
          id="showRejectedPfRequestsSwitch"
          [(ngModel)]="showRejected"
          (change)="onShowRejectedChanged()"
        />
        <label class="form-check-label" for="showRejectedPfRequestsSwitch">Show rejected</label>
      </div>
      <button type="button" class="btn btn-primary" (click)="refreshData()">Refresh</button>
      <button
        type="button"
        class="btn btn-success ms-2"
        [disabled]="!selectedRowCount"
        (click)="approveSelectedRequests()"
        *ngIf="showApprovalActions()"
      >
        Approve
      </button>
      <button
        type="button"
        class="btn btn-danger ms-2"
        [disabled]="!selectedRowCount"
        (click)="rejectSelectedRequests()"
        *ngIf="showApprovalActions()"
      >
        Reject
      </button>
      <a
        href="javascript:void(0)"
        class="topbar-item"
        (click)="exportExcel()"
        placement="top-right"
        container="body"
        ngbTooltip="Export to Excel"
        aria-label="Export to Excel"
      >
        <span class="far fa-file-excel fa-lg"></span>
      </a>
    </div>
  </div>
</div>

<div class="container container-content container-max-width" (window:resize)="onResize()" [style.height]="containerHeight">
  <div class="landing-main mt-3">
    <grid-filter-pills [gridApi]="gridApi" *ngIf="gridApi"></grid-filter-pills>
    <ag-grid-angular
      #agGrid
      id="ApprovePfAdHocRequestsGrid"
      style="width: 100%; height: 540px"
      class="ag-theme-balham"
      [gridOptions]="gridOptions"
      [rowData]="rowData"
      [excelStyles]="headerStyle"
      [masterDetail]="true"
      [pagination]="true"
      rowSelection="multiple"
      [rowMultiSelectWithClick]="true"
      [suppressRowClickSelection]="false"
      (gridReady)="onGridReady($event)"
      (selectionChanged)="onSelectionChanged()"
      (filterChanged)="onFilterChanged($event)"
    >
    </ag-grid-angular>
  </div>
</div>
